import { useDesignMaxTheme } from "@/packages";
import { FONT, RADIUS } from "@/styles";
import { Center } from "@chakra-ui/react";
import { type PropsWithChildren } from "react";

export const Alert = ({ children }: PropsWithChildren) => {
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    return (
        <Center
            w={isMobile ? "280px" : "720px"}
            h={isMobile ? "84px" : "120px"}
            p={isMobile ? "0 72px" : "0 24px"}
            boxSizing="border-box"
            color={COLORS.white}
            bgColor={COLORS.black}
            sx={isMobile ? { ...FONT("pretendard", 14, 500), ...RADIUS(2) } : { ...FONT("pretendard", 20, 500) }}
        >
            {children}
        </Center>
    );
};
